import React from 'react'
import toNumber from 'lodash/toNumber'
import type { ForwardedRef } from 'react'
import type RGL from 'react-grid-layout'
import { CloseButton, HideIf, HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useDashboardContext } from './Context'
import styles from './GridItem.module.scss'
import { WidgetOptions } from './widgetOptions'

export const GridItem = React.forwardRef(
  (
    props: {
      'data-grid': RGL.Layout
      children?: React.ReactNode
      style?: React.CSSProperties
    },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { 'data-grid': item, children } = props
    let height = typeof props.style.height === 'string' ? props.style.height?.replace('px', '') : props.style.height
    height = toNumber(height)
    const { onRemoveWidget, resolveWidget, setting } = useDashboardContext()
    const isLocked = setting.isLocked

    return (
      <div {...props} ref={ref} className="border border-1 shadow-sm">
        <HideIf condition={isLocked}>{children}</HideIf>

        <div className="p-2">
          <HideIf condition={isLocked}>
            <HorizontalStack className={'justify-content-between mb-1 '} gap={1}>
              <WidgetOptions />
              <div className={`react-grid-dragHandleExample ${styles.dragHandle} flex-fill opacity-0`} ref={ref}>
                <Icon name="arrows-up-down-left-right" />
              </div>
              <CloseButton onClick={() => onRemoveWidget(item?.i)} />
            </HorizontalStack>
          </HideIf>

          {resolveWidget(item?.i)?.({ height })}
        </div>
      </div>
    )
  }
)
